
















import {Mixins, Component, Prop} from "vue-property-decorator";
import UserMixin from '../../../mixins/UserMixin';
import UserIcon from "../../common/UserIcon.vue";

@Component({
    components: {UserIcon}
})
export default class Speaker extends Mixins(UserMixin) {
    @Prop({default: true}) isSelectable: boolean;

}
